<template>
  <v-card class="com-pc-card rw-list">
    <div class="com-pc-card-header rw-header">
      <span class="com-pc-card-title">発表情報概況</span>
      <!-- 凡例 -->
      <v-tooltip
          v-if="this.tabIndex === 0 || this.tabIndex === 1"
          bottom
          max-width="450px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2"
              >help_outline</v-icon
            >
          </template>
          <!-- 洪水予報 -->
          <span v-if="this.tabIndex === 0">
            {{ legendStr.fld.title }}
            <br />
            <span>
              <span>
                {{ legendStr.tmStg.tmStgMsg1 }}
                <br />
                {{ legendStr.tmStg.tmStgMsg2 }}
                <br />
              </span>
              <span class="text-flood-occurrence legend-stg-span mb-1">
                {{ legendStr.tmStg.occurrence }}
              </span>
              <br />
              <span class="text-flood-danger legend-stg-span mb-1">
                {{ legendStr.tmStg.danger }}</span
              >
              <br />
              <span class="text-flood-refuge legend-stg-span mb-1">
                {{ legendStr.tmStg.refuge }}
              </span>
              <br />
              <span class="text-flood-warn legend-stg-span mb-1">
                {{ legendStr.tmStg.warn }}
              </span>
            </span>
          </span>
          <!-- ダム放流通知 -->
          <span v-if="this.tabIndex === 1">
            {{ legendStr.dam.title }}
            <br />
            {{ legendStr.dam.damMsg1 }}
            <br />
            {{ legendStr.dam.damMsg2 }}
          </span>
        </v-tooltip>
      <v-spacer></v-spacer>
      <span class="rw-time pr-4">{{ appTime }}</span>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="pcPanelMode"
            icon
            dark
            small
            class="mr-4"
            @click="returnWindowMode"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>fullscreen_exit</v-icon>
          </v-btn>
        </template>
        <span>{{ this.tooltipStr.panelModeOff }}</span>
      </v-tooltip>
    </div>

    <div class="rw-box">
      <!-- 模式図 -->
      <div class="rw-box-figure">
        <div class="tab">
          <!-- 表示切替タブ -->
          <v-btn
            class="com-btn mr-2"
            :class="rwBtnStates(0)"
            @click="clickTab(0)"
            >洪水予報等</v-btn
          >
          <v-btn
            class="com-btn mr-2"
            :class="rwBtnStates(1)"
            @click="clickTab(1)"
            >ダム放流通知</v-btn
          >
          <v-btn
            v-if="isFldCtl"
            class="com-btn"
            :class="rwBtnStates(2)"
            @click="clickTab(2)"
            >水防警報</v-btn
          >
        </div>
        <div class="ml-2">
          <v-btn class="mr-4" v-if="overviewLevel != 80" @click="retrunLevel()">
            <v-icon left>keyboard_arrow_left</v-icon>戻る
          </v-btn>
          <span class="rw-target py-1 px-2">{{ getTargetPref() }}</span>
        </div>
        <object
          id="rw_overview"
          type="image/svg+xml"
          :data="overviewUrl"
        ></object>
      </div>
      <div class="rw-box-warn">
        <!-- 河川予警報一覧 -->
        <div class="ma-0 pa-0 rw-box-list" v-if="tabIndex === 0">
          <!-- 洪水予報一覧 -->
          <v-col
            class="rw-no-regist pa-6"
            v-if="!riverWarns.fldfr || riverWarns.fldfr.length == 0"
            >{{ this.$store.state.app.config.messageConfig.rwNoRegist }}</v-col
          >
          <v-list
            class="ma-0 py-1"
            light
            v-for="(fldfr, fldfrIdx) in riverWarns.fldfr"
            :key="'fldfrIdx' + fldfrIdx"
          >
            <v-list-item
              @click="
                clickRiverWarnList(
                  fldfr.id,
                  fldfr.cd,
                  fldfr.type,
                  fldfr.annNo,
                  fldfr.annTime,
                  fldfr.docType
                )
              "
            >
              <v-list-item-content class="rw-content-warn">
                <v-list-item-title class="rw-item-warn">
                  <span class="rw-span-warn-box">
                    <!-- 発令中予警報 -->
                    <span
                      v-if="fldfr.lvl == 0"
                      class="text-flood-normal rw-span-warn-normal"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                    >
                      {{ fldfr.kndNmM }}
                    </span>
                    <span
                      v-if="fldfr.lvl == 30"
                      class="text-flood-warn rw-span-warn"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl2 }}</span
                    >
                    <span
                      v-if="fldfr.lvl == 60"
                      class="text-flood-refuge rw-span-warn"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl3 }}</span
                    >
                    <span
                      v-if="fldfr.lvl == 80"
                      class="text-flood-danger rw-span-warn"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl4 }}</span
                    >
                    <span
                      v-if="fldfr.lvl == 90"
                      class="text-flood-occurrence rw-span-warn"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                      >{{ fldfr.kndNmM
                      }}{{ config.messageConfig.alertLvl.fldfrLvl5 }}</span
                    >
                    <!-- <span class="rw-span-time"> -->
                    <!-- 新着 -->
                    <!-- <span v-if="isNew(fldfr.annTime)" class="rw_span_new mr-2"
                        >新着</span
                      >
                    </span> -->
                  </span>
                  <!-- 区間名 -->
                  <span class="rw-span-rvr">{{ fldfr.nm }}</span>
                </v-list-item-title>
                <!-- 見出し -->
                <v-list-item-subtitle class="rw-item-heading pb-1">
                  <span class="rw-span-text">{{ fldfr.heading }}&nbsp;</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <!-- 基準観測所 -->
              <v-list-item-content class="py-1">
                <v-list-item-title>
                  <v-row class="ma-0">
                    <span
                      class="pa-1"
                      v-for="(obs, obsIdx) in fldfr.stgObs"
                      :key="'fldfrIdx' + fldfrIdx + 'obsIdx' + obsIdx"
                      >{{ obs.obsNm }}</span
                    >
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <!-- 対象市町村 -->
              <v-list-item-content class="rw-content-twn py-1">
                <v-list-item-title>
                  <v-row class="ma-0">
                    <div
                      v-for="(pref, prefIdx) in fldfr.prefTwn"
                      :key="'fldfrIdx' + fldfrIdx + 'prefIdx' + prefIdx"
                    >
                      <span class="pa-1"> 【{{ pref.prefNm }}】</span>
                      <v-row class="ma-0">
                        <span
                          class="pa-1"
                          v-for="(town, townIdx) in pref.twn"
                          :key="
                            'fldfrIdx' +
                              fldfrIdx +
                              'prefIdx' +
                              prefIdx +
                              'townIdx' +
                              townIdx
                          "
                          >{{ town.twnNm }}</span
                        >
                      </v-row>
                    </div>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <!-- 発令日時 -->
              <v-list-item-content class="py-1">
                <span class="rw-span-time">
                  <!-- 新着 -->
                  <span v-if="isNew(fldfr.annTime)" class="rw_span_new mr-2"
                    >新着</span
                  >
                  <!-- 発令日時 -->
                  {{ getDispDate(fldfr.annTime) }}
                  <!-- 号 -->
                  <span class="rw-span-annNo">第{{ fldfr.annNo }}号</span>
                </span>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </div>
        <!-- ダム放流通知一覧 -->
        <div class="ma-0 pa-0 rw-box-list" v-if="tabIndex === 1">
          <v-col
            class="rw-no-regist pa-6"
            v-if="!riverWarns.damdsch || riverWarns.damdsch.length == 0"
            >{{ this.$store.state.app.config.messageConfig.rwNoRegist }}</v-col
          >
          <v-list
            class="ma-0 py-1"
            light
            v-for="(damdsch, damdschIdx) in riverWarns.damdsch"
            :key="'damdschIdx' + damdschIdx"
          >
            <v-list-item
              @click="
                clickRiverWarnList(
                  damdsch.damdschId,
                  damdsch.damdschCd,
                  'damdsch',
                  damdsch.annNo,
                  damdsch.annTime,
                  damdsch.docType
                )
              "
            >
              <v-list-item-content class="rw-content-warn">
                <v-list-item-title class="rw-item-warn">
                  <!-- 発令中予警報 -->
                  <span class="rw-span-warn-box">
                    <span
                      v-if="damdsch.damdschLvl == 70"
                      class="text-damdsch-disasteroperating rw-span-warn"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                      >{{ damdsch.damdschKndNm }}</span
                    >
                    <span
                      v-if="damdsch.damdschLvl == 50"
                      class="text-damdsch-riserving rw-span-warn"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                      >{{ damdsch.damdschKndNm }}</span
                    >
                    <span
                      v-if="damdsch.damdschLvl == 0"
                      class="text-damdsch-normal rw-span-warn-normal"
                      :class="pcPanelMode ? 'rw-span-expanel' : ''"
                      >{{ damdsch.damdschKndNm }}</span
                    >
                  </span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-title class="rw-item-warn">
                  <!-- 河川名・水系名 -->
                  <span class="rw-span-rvr">{{ damdsch.damdschNm }}</span>
                </v-list-item-title>
              </v-list-item-content>
              <!-- 対象市町村 -->
              <v-list-item-content class="rw-content-twn py-1">
                <v-list-item-title>
                  <v-row class="ma-0">
                    <div
                      v-for="(pref, prefIdx) in damdsch.prefTwn"
                      :key="'damdschIdx' + damdschIdx + 'prefIdx' + prefIdx"
                    >
                      <span class="pa-1">【{{ pref.prefNm }}】</span>
                      <v-row class="ma-0">
                        <span
                          class="pa-1"
                          v-for="(town, townIdx) in pref.twn"
                          :key="
                            'damdschIdx' +
                              damdschIdx +
                              'prefIdx' +
                              prefIdx +
                              'townIdx' +
                              townIdx
                          "
                          >{{ town.twnNm }}</span
                        >
                      </v-row>
                    </div>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content class="py-1">
                <span class="rw-span-time">
                  <!-- 新着 -->
                  <span v-if="isNew(damdsch.annTime)" class="rw_span_new mr-2"
                    >新着</span
                  >
                  <!-- 発令日時 -->
                  {{ getDispDate(damdsch.annTime) }}
                  <!-- 号 -->
                  <span class="rw-span-annNo">第{{ damdsch.annNo }}号</span>
                </span>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </div>
        <!-- 水防警報一覧 -->
        <div class="ma-0 pa-0 rw-box-list" v-if="tabIndex === 2">
          <v-col
            class="rw-no-regist pa-6"
            v-if="!riverWarns.fldctl || riverWarns.fldctl.length == 0"
            >{{ this.$store.state.app.config.messageConfig.rwNoRegist }}</v-col
          >
          <v-list
            class="ma-0 py-1"
            light
            v-for="(fldctl, fldctlIdx) in riverWarns.fldctl"
            :key="'fldctlIdx' + fldctlIdx"
          >
            <v-list-item
              @click="
                clickRiverWarnList(
                  fldctl.fldctlId,
                  fldctl.fldctlCd,
                  'fldctl',
                  fldctl.annNo,
                  fldctl.annTime,
                  fldctl.docType
                )
              "
            >
              <v-list-item-content class="rw-content-warn">
                <v-list-item-title class="rw-item-warn">
                  <!-- 発令中予警報 -->
                  <span class="rw-span-warn-box">
                    <span
                      v-if="fldctl.fldctlLvl == 0"
                      class="text-fldctl-normal rw-span-warn-normal"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                    <span
                      v-if="fldctl.fldctlLvl == 10"
                      class="text-fldctl-standby rw-span-warn"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                    <span
                      v-if="fldctl.fldctlLvl == 20"
                      class="text-fldctl-preparation rw-span-warn mb-1"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                    <span
                      v-if="fldctl.fldctlLvl == 40"
                      class="text-fldctl-dispatch rw-span-warn mb-1"
                      >{{ fldctl.fldctlKndNm }}</span
                    >
                  </span>

                  <!-- 河川名・水系名 -->
                  <span class="rw-span-rvr">{{ fldctl.fldctlNm }}</span>
                </v-list-item-title>
                <!-- 見出し -->
                <v-list-item-subtitle class="rw-item-heading pb-1">
                  <span class="rw-span-text">{{ fldctl.heading }}&nbsp;</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <!-- 基準観測所 -->
              <v-list-item-content class="py-1">
                <v-list-item-title>
                  <v-row class="ma-0">
                    <span
                      class="pa-1"
                      v-for="(obs, obsIdx) in fldctl.stgObs"
                      :key="'fldctlIdx' + fldctlIdx + 'obsIdx' + obsIdx"
                      >{{ obs.obsNm }}</span
                    >
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <!-- 対象市町村 -->
              <v-list-item-content class="rw-content-twn py-1">
                <v-list-item-title>
                  <v-row class="ma-0">
                    <div
                      v-for="(pref, prefIdx) in fldctl.prefTwn"
                      :key="'fldctlIdx' + fldctlIdx + 'prefIdx' + prefIdx"
                    >
                      <span class="pa-1">【{{ pref.prefNm }}】</span>
                      <v-row class="ma-0">
                        <span
                          class="pa-1"
                          v-for="(town, townIdx) in pref.twn"
                          :key="
                            'fldctlIdx' +
                              fldctlIdx +
                              'prefIdx' +
                              prefIdx +
                              'townIdx' +
                              townIdx
                          "
                          >{{ town.twnNm }}</span
                        >
                      </v-row>
                    </div>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content class="py-1">
                <!-- 発令日時 -->
                <span class="rw-span-time">
                  <!-- 新着 -->
                  <span
                    v-if="isNew(fldctl.annTime)"
                    class="rw_span_new mb-1 mr-2"
                    >新着</span
                  >
                  {{ getDispDate(fldctl.annTime) }}
                  <!-- 号 -->
                  <span class="rw-span-annNo">第{{ fldctl.annNo }}号</span>
                </span>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </div>
      </div>
    </div>

    <v-card v-if="isLoading === 1" class="vc-dialog-content mt-0 pt-0">
      <v-progress-circular
        indeterminate
        :size="30"
        :width="5"
      ></v-progress-circular>
    </v-card>
  </v-card>
</template>
<script>
import mixin from "./../../../lib/mixin.js";
import Util from "./../../../lib/util.js";
import PageLog from "./../../../lib/pageLog.js";
import color from "./../../../scss/color.scss";
export default {
  name: "rw-list",
  mixins: [mixin],
  data() {
    return {
      tabIndex: 0,
      isLoading: 0,
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[RwList] mounted()");

    // パラメータによって初期表示するタブを変更
    let type = this.$route.query["type"];
    if (type === "fldfr") {
      this.tabIndex = 0;
    } else if (type === "damdsch") {
      this.tabIndex = 1;
    } else if (type === "fldctl") {
      this.tabIndex = 2;
    }

    // パラメータから地方・都道府県コードを取得
    let areaCd = this.$route.query["area"];
    this.$log.debug("[RwOverview] areaCd:" + areaCd);
    let prefCd = this.$route.query["pref"];
    this.$log.debug("[RwOverview] prefCd:" + prefCd);

    // 読み込み中
    this.isLoading = 1;

    if (areaCd && prefCd) {
      this.$log.debug("[TmOverList] mounted() areaCd, prefCdから初期表示");
      setTimeout(() => {
        this.$store.dispatch("map/moveMapPrefecture", Number(prefCd));
        this.$store.commit("RiverWarn/setOverviewLevel", Number(areaCd));
      }, 200);
      setTimeout(() => {
        this.setRwOvSvg();
        this.getRiverWarnsLvl();
        this.getRiverWarns();
      }, 200);
    } else if (areaCd) {
      this.$log.debug("[TmOverList] mounted() areaCdから初期表示");
      setTimeout(() => {
        this.$store.dispatch("map/moveMapRegion", Number(areaCd));
        this.$store.commit("RiverWarn/setOverviewLevel", Number(areaCd));
      }, 200);
      setTimeout(() => {
        this.getRiverWarnsLvl();
        this.getRiverWarns();
      }, 200);
      setTimeout(() => {
        // 概況模式図を再描画
        this.setRwOvSvg();
      }, 200);
    } else if (this.pcPanelMode) {
      this.$log.debug("[TmOverList] mounted() 緯度経度から初期表示");
      setTimeout(() => {
        this.getRiverWarnsNew();
        this.getRiverWarnsLvl();
      }, 200);
      setTimeout(() => {
        // 概況模式図を再描画
        this.setRwOvSvg();
      }, 200);
    }
  },
  computed: {
    /** 表示日時 */
    appTime: {
      get() {
        return Util.formatDate(this.$store.state.app.appTime);
      },
    },
    /** 概況模式図の表示レベル */
    overviewLevel: {
      get() {
        return this.$store.state.RiverWarn.overviewLevel;
      },
    },
    /** 概況模式図の選択都道府県 */
    overviewPref: {
      get() {
        return this.$store.state.RiverWarn.overviewPref;
      },
    },
    /** 概況模式図のSVGのURL */
    overviewUrl: {
      get() {
        const level = this.$store.state.RiverWarn.overviewLevel;
        let url = this.$store.state.RiverWarn.overviewUrl;
        url = url + "/" + level + ".svg";
        return url;
      },
    },
    /** 概況模式図の地方毎のステータス */
    overviewState: {
      get() {
        return this.$store.state.RiverWarn.overviewState;
      },
    },
    /**
     * 表示範囲の河川予警報データ
     */
    riverWarns: {
      get() {
        return this.$store.state.RiverWarn.riverWarnsFullList;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTimeRoundRw,
          townsAcqTime: this.$store.state.map.townsAcqTime,
        };
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /** PCパネル拡大表示モード */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
  },
  methods: {
    /**
     * タブクリック
     */
    clickTab(index) {
      this.$log.debug("[RwOverview] clickTab(" + index + ")");
      this.tabIndex = index;
      let type = "";
      let pLogNm = "";
      if (index === 0) {
        type = "fldfr";
        pLogNm = "oview_ff";
      } else if (index === 1) {
        type = "damdsch";
        pLogNm = "oview_dd";
      } else if (index === 2) {
        type = "fldctl";
        pLogNm = "oview_fc";
      }
      // アクセスログ出力
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.type = type;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 更新ボタンクリック
     */
    renew() {
      this.$log.debug("[RwOverview] renew()");
      this.$store.commit("app/renewTime");
    },
    /**
     * ウィンドウモード戻るクリックイベント
     */
    returnWindowMode() {
      this.$log.debug("[TmOverList] returnWindow()");
      this.$store.commit("app/setPcPanelMode", false);
      this.$store.commit("app/setPcPanelModeContent", "");
      this.$store.commit("map/mapRedraw");
      this.$store.commit("RiverWarn/setOverviewPref", 0);
      let setQuery = Object.assign({}, this.$route.query);
      delete setQuery["ext"];
      delete setQuery["ovmd"];
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * リストクリック
     */
    clickRiverWarnList(id, cd, type, annNo, annTime, docType) {
      this.$log.debug(
        "[Riverwarn] clickRiverWarnList(" +
          id +
          "," +
          cd +
          "," +
          type +
          "," +
          annNo +
          "," +
          annTime +
          "," +
          docType +
          ")"
      );
      if (this.pcPanelMode) {
        // PCパネル拡大表示モードの場合は、モードをfalseに設定し河川予警報画面へ遷移
        this.$store.commit("app/setPcPanelMode", false);
        switch (type) {
          case "fldfr":
            type = 10;
            break;
          case "evstg":
            type = 11;
            break;
          case "fldctl":
            type = 20;
            break;
          case "damdsch":
            type = 30;
            break;
        }
        // ストアに区間コード、予警報タイプを設定
        this.$store.commit("RiverWarn/setSelectedWarnReq", {
          type: type,
          cd: cd,
        });
        // 河川予警報画面に遷移
        this.routerPushRw("/pc/rw");
      }
    },
    /**
     * 概況模式図を表示色を反映
     */
    setRwOvSvg() {
      this.$log.debug("[RwOverview] setRwOvSvg()");
      const elmE = document.getElementById("rw_overview");
      const elm = elmE.contentDocument;

      let ovState;
      if (this.overviewLevel === 80) {
        this.$log.debug("[RwOverview] setRwOvSvg overviewLevel === 80");
        // 全国レベルのSVG初期化
        if (this.tabIndex === 0) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 0");
          ovState = this.overviewState.area.fldfr;
        } else if (this.tabIndex === 1) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 1");
          ovState = this.overviewState.area.damdsch;
        } else if (this.tabIndex === 2) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 2");
          ovState = this.overviewState.area.fldctl;
        }

        // イベント張り付け
        for (const area of this.$store.state.app.config.mapConfig
          .regionLatLngList) {
          const pathElm = elm.getElementById(area.areaCd);
          if (pathElm == null) {
            continue;
          }
          pathElm.style.cursor = "pointer";
          pathElm.style.setProperty("fill", "#fff");

          // 概況模式図のクリックイベントを登録
          pathElm.addEventListener("click", () => {
            this.$log.debug(
              "[RwOverview] setRwOvSvg click(" + area.areaCd + ")"
            );
            // 拡大表示時
            let setQuery = Object.assign({}, this.$route.query);
            delete setQuery.pref;
            setQuery.area = area.areaCd;
            this.$router.replace({
              path: this.$route.path,
              query: setQuery,
            });
            this.$store.dispatch("map/moveMapRegion", area.areaCd);
            this.$store.commit("RiverWarn/setOverviewLevel", area.areaCd);
            this.$store.commit("RiverWarn/setOverviewPref", 0);
          });
        }
        this.ovLevel = this.overviewLevel;
      } else {
        this.$log.debug("[RwOverview] setRwOvSvg overviewLevel !== 80");
        // 地方レベルのSVG初期化
        if (this.tabIndex === 0) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 0");
          ovState = this.overviewState.pref.fldfr;
        } else if (this.tabIndex === 1) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 1");
          ovState = this.overviewState.pref.damdsch;
        } else if (this.tabIndex === 2) {
          this.$log.debug("[RwOverview] setRwOvSvg tabIndex === 2");
          ovState = this.overviewState.pref.fldctl;
        }

        // イベント張り付け
        for (const pref of this.$store.state.app.config.mapConfig
          .prefLatLngList) {
          const pathElm = elm.getElementById(pref.prefCd);
          if (pathElm == null) {
            continue;
          }
          pathElm.style.cursor = "pointer";
          pathElm.style.setProperty("fill", "#fff");

          // 概況模式図のクリックイベントを登録
          pathElm.addEventListener("click", () => {
            this.$log.debug(
              "[RwOverview] setRwOvSvg click(" + pref.prefCd + ")"
            );
            let setQuery = Object.assign({}, this.$route.query);
            setQuery.area = this.overviewLevel;
            setQuery.pref = pref.prefCd;
            this.$router.replace({
              path: this.$route.path,
              query: setQuery,
            });
            this.$store.dispatch("map/moveMapPrefecture", pref.prefCd);
            this.$store.commit("RiverWarn/setOverviewPref", pref.prefCd);
          });
        }
        this.ovLevel = this.overviewLevel;
      }

      for (const st of ovState) {
        var pathElm;
        if (this.overviewLevel === 80) {
          pathElm = elm.getElementById(st.areaCd);
        } else {
          pathElm = elm.getElementById(st.prefCd);
        }
        if (pathElm == null) {
          continue;
        }
        pathElm.style.cursor = "pointer";

        if (this.tabIndex === 0) {
          // 洪水予報
          switch (st.lvl) {
            case 30:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 30"
              );
              pathElm.style.setProperty("fill", color.stageWarning);
              break;
            case 60:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 60"
              );
              pathElm.style.setProperty("fill", color.stageRefuge);
              break;
            case 80:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 80"
              );
              pathElm.style.setProperty("fill", color.stageDanger);
              break;
            case 90:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 0, lvl === 90"
              );
              pathElm.style.setProperty("fill", color.stageOver);
              break;
          }
        } else if (this.tabIndex === 1) {
          // ダム放流通知
          switch (st.lvl) {
            case 50:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 1, lvl === 50"
              );
              pathElm.style.setProperty("fill", color.damdschStorop);
              break;
            case 70:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 1, lvl === 70"
              );
              pathElm.style.setProperty("fill", color.damdschPrevop);
              break;
          }
        } else if (this.tabIndex === 2) {
          // 水防警報
          switch (st.lvl) {
            case 10:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 2, lvl === 10"
              );
              pathElm.style.setProperty("fill", color.fldctlStandby);
              break;
            case 20:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 2, lvl === 20"
              );
              pathElm.style.setProperty("fill", color.fldctlPreparation);
              break;
            case 40:
              this.$log.debug(
                "[RwOverview] setRwOvSvg tabIndex === 2, lvl === 40"
              );
              pathElm.style.setProperty("fill", color.fldctlDispatch);
              break;
          }
        }
      }
    },
    /**
     * 全国レベルへ戻る
     */
    retrunLevel() {
      this.$log.debug("[RwOverview] retrunLevel()");
      this.isLoading = 1;
      // 拡大表示時
      if (this.pcPanelMode) {
        let setQuery = Object.assign({}, this.$route.query);
        setQuery.area = 80;
        delete setQuery.pref;
        this.$router.replace({
          path: this.$route.path,
          query: setQuery,
        });
      }
      // 地図の表示位置を変更
      this.$store.dispatch("map/moveMapNationwide");
      this.$store.commit("RiverWarn/setOverviewLevel", 80);
      this.$store.commit("RiverWarn/setOverviewPref", 0);
    },
    /**
     * 予警報情報を取得
     */
    getRiverWarnsNew() {
      this.$log.debug("[RwOverview] getRiverWarnsNew()");
      // アクセスログ出力
      // ログ名称設定
      let pLogNm = "";
      if (this.tabIndex == 0) pLogNm = "oview_ff";
      if (this.tabIndex == 1) pLogNm = "oview_dd";
      if (this.tabIndex == 2) pLogNm = "oview_fc";
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      setTimeout(() => {
        // 初回取得時は、パラメータの緯度経度から予警報を取得する
        var param;
        if (this.pcPanelMode) {
          // PCパネルモードはパラメータではなくストアから設定
          param = {
            appTime: this.reqParam.appTime,
            minlat: this.$store.state.map.minCoord[0],
            minlon: this.$store.state.map.minCoord[1],
            maxlat: this.$store.state.map.maxCoord[0],
            maxlon: this.$store.state.map.maxCoord[1],
            zm: this.$store.state.map.zoom,
            townsAcqTime: this.reqParam.townsAcqTime,
          };
        }
        // 河川予警報一覧(全体)取得
        this.$store.dispatch("RiverWarn/getRwListFull", param);
      }, 200);
    },
    /**
     * 模式図の表示レベルから予警報情報を取得
     */
    getRiverWarns() {
      this.$log.debug("[RwOverview] getRiverWarns()");
      // アクセスログ出力
      // ログ名称設定
      let pLogNm = "";
      if (this.tabIndex == 0) pLogNm = "oview_ff";
      if (this.tabIndex == 1) pLogNm = "oview_dd";
      if (this.tabIndex == 2) pLogNm = "oview_fc";
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      var prefs = [];
      setTimeout(() => {
        if (this.overviewLevel === 80) {
          this.$log.debug("[RwOverview] getRiverWarns 全国選択時");
          // 河川予警報一覧(全体)取得
          this.$store.dispatch("RiverWarn/getRiverWarnsLvl", {
            appTime: this.reqParam.appTime,
          });
          prefs = [
            "102",
            "103",
            "104",
            "105",
            "201",
            "301",
            "401",
            "501",
            "601",
            "701",
            "801",
            "901",
            "1001",
            "1101",
            "1201",
            "1301",
            "1401",
            "1901",
            "1501",
            "1601",
            "1701",
            "2001",
            "2101",
            "2201",
            "2301",
            "2401",
            "1801",
            "2501",
            "2601",
            "2701",
            "2801",
            "2901",
            "3001",
            "3101",
            "3201",
            "3301",
            "3401",
            "3501",
            "3601",
            "3701",
            "3801",
            "3901",
            "4001",
            "4101",
            "4201",
            "4301",
            "4401",
            "4501",
            "4601",
            "4701",
          ];
          this.$store.dispatch("RiverWarn/getRiverWarnsPrefs", {
            appTime: this.reqParam.appTime,
            prefs: prefs,
            townsAcqTime: this.reqParam.townsAcqTime,
          });
          // } else if (this.overviewLevel >= 81 && this.overviewLevel <= 90) {
        } else if (this.overviewPref === 0) {
          this.$log.debug("[RwOverview] getRiverWarns 地方選択時");
          switch (this.overviewLevel) {
            case 81:
              prefs = ["102", "103", "104", "105"];
              break;
            case 82:
              prefs = ["201", "301", "401", "501", "601", "701"];
              break;
            case 83:
              prefs = [
                "801",
                "901",
                "1001",
                "1101",
                "1201",
                "1301",
                "1401",
                "1901",
              ];
              break;
            case 84:
              prefs = ["1501", "1601", "1701", "2001"];
              break;
            case 85:
              prefs = ["2101", "2201", "2301", "2401"];
              break;
            case 86:
              prefs = ["1801", "2501", "2601", "2701", "2801", "2901", "3001"];
              break;
            case 87:
              prefs = ["3101", "3201", "3301", "3401", "3501"];
              break;
            case 88:
              prefs = ["3601", "3701", "3801", "3901"];
              break;
            case 89:
              prefs = ["4001", "4101", "4201", "4301", "4401", "4501", "4601"];
              break;
            case 90:
              prefs = ["4701"];
              break;
          }
          // 河川予警報一覧(地方)取得
          this.$store.dispatch("RiverWarn/getRiverWarnsPrefs", {
            appTime: this.reqParam.appTime,
            prefs: prefs,
            townsAcqTime: this.reqParam.townsAcqTime,
          });
        } else {
          // 都道府県レベル
          this.$log.debug("[RwOverview] getRiverWarns 都道府県選択時");
          prefs = [];
          prefs.push(this.overviewPref);
          // 河川予警報一覧(地方)取得
          this.$store.dispatch("RiverWarn/getRiverWarnsPrefs", {
            appTime: this.reqParam.appTime,
            prefs: prefs,
            townsAcqTime: this.reqParam.townsAcqTime,
          });
        }
      }, 200);
    },
    /**
     * 日付を表示フォーマットに変換
     */
    getDispDate(annTime) {
      this.$log.debug("[RwOverview] getDispDate(" + annTime + ")");
      return Util.formatDate24(annTime, "MM/DD HH:mm");
    },
    /**
     * 新着表示有無
     */
    isNew(annTime) {
      this.$log.debug("[RwOverview] isNew(" + annTime + ")");
      let time = Util.toDate(annTime);
      let addTime = Util.addDate(
        time,
        0,
        this.$store.state.app.config.riverWarnConfig.isNewTime,
        0
      );
      if (this.$store.state.app.appTime <= addTime) {
        this.$log.debug("[RwOverview] isNew = true");
        return true;
      } else {
        this.$log.debug("[RwOverview] isNew = false");
        return false;
      }
    },
    /**
     * 模式図の河川予警報危険度を取得
     */
    getRiverWarnsLvl() {
      this.$log.debug("[RwOverview] getRiverWarnsLvl()");
      setTimeout(() => {
        this.$store.dispatch("RiverWarn/getRiverWarnsLvl", {
          appTime: this.reqParam.appTime,
        });
      }, 500);
    },
    /**
     * 予警報種別ボタン点滅
     */
    rwBtnStates(idx) {
      this.$log.debug("[RwOverview] rwBtnStates(" + idx + ")");
      // 選択中の予警報
      if (idx === this.tabIndex) {
        return "com-btn-on";
        // 選択していない予警報で発令中の場合に点滅
      } else if (
        idx === 0 &&
        this.riverWarns.fldfr &&
        this.riverWarns.fldfr.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 1 &&
        this.riverWarns.damdsch &&
        this.riverWarns.damdsch.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 2 &&
        this.riverWarns.fldctl &&
        this.riverWarns.fldctl.length > 0
      ) {
        return "com-btn-flash";
      }
    },
    /**
     * 表示対象
     */
    getTargetPref() {
      let target = "";
      let areaCd = this.overviewLevel;
      let prefCd = this.overviewPref;

      if (prefCd === 0) {
        // prefCdが0の場合は、全国か地方が対象
        switch (areaCd) {
          // case 80:
          //   target = "全国";
          //   break;
          case 81:
            target = "北海道";
            break;
          case 82:
            target = "東北";
            break;
          case 83:
            target = "関東";
            break;
          case 84:
            target = "北陸";
            break;
          case 85:
            target = "中部";
            break;
          case 86:
            target = "近畿";
            break;
          case 87:
            target = "中国";
            break;
          case 88:
            target = "四国";
            break;
          case 89:
            target = "九州";
            break;
          case 90:
            target = "沖縄";
            break;
        }
      } else {
        // prefCdが0以外の場合は、都道府県が対象

        // 北海道は分割されているので、どのコードも北海道を表示
        if (
          prefCd === 101 ||
          prefCd === 102 ||
          prefCd === 103 ||
          prefCd === 104 ||
          prefCd === 105
        ) {
          target = "北海道";
        } else {
          // 設定ファイルから該当都道府県名を探す
          for (const pref of this.$store.state.app.config.mapConfig
            .prefLatLngList) {
            if (pref.prefCd === prefCd) {
              target = pref.prefNm;
              break;
            }
          }
        }
      }
      if (target !== "") {
        target += "表示中";
      }
      return target;
    },
  },
  watch: {
    overviewUrl() {
      this.$log.debug("[RwList] watch(overviewUrl)");
      // 読み込み中
      this.isLoading = 1;
      // 概況模式図を再描画
      this.getRiverWarns();
      this.getRiverWarnsLvl();
    },
    /**
     * ストアの概況模式図の状態を監視
     */
    overviewState() {
      this.$log.debug("[RwList] watch(overviewState)");
      // 概況模式図を再描画
      // this.setRwOvSvg();
      this.setRwOvSvg();
    },
    /**
     * 時刻の変更を監視
     */
    appTime() {
      this.$log.debug("[RwList] watch(appTime)");
      // 再描画
      this.setRwOvSvg();
    },
    /**
     * 表示タブの選択状態を監視
     */
    tabIndex() {
      this.$log.debug("[RwList] watch(tabIndex)");
      // 概況模式図を再描画
      this.setRwOvSvg();
    },
    /**
     *  観測日時(ファイル取得用)を監視
     */
    reqParam() {
      this.$log.debug("[RwList] watch(reqParam)");
      // 予警報情報を取得
      let areaCd = this.$route.query["area"];
      this.$log.debug("[RwOverview] areaCd:" + areaCd);
      let prefCd = this.$route.query["pref"];
      this.$log.debug("[RwOverview] prefCd:" + prefCd);
      if (areaCd || prefCd) {
        this.$log.debug("[RwList] watch(reqParam) areaCd, prefCdから取得");
        this.getRiverWarns();
        this.getRiverWarnsLvl();
      } else {
        this.$log.debug("[RwList] watch(reqParam) 緯度経度から取得");
        this.getRiverWarnsNew();
        this.getRiverWarnsLvl();
      }
    },
    /**
     * 表示範囲の河川予警報データ
     */
    riverWarns() {
      this.$log.debug("[RwList] watch(riverWarns)");
      this.isLoading = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../scss/kwb.scss";

.rw-title {
  vertical-align: middle;
}

.rw-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .rw-header {
    display: flex;
    .rw-time {
      color: white;
    }
  }

  .rw-box {
    display: flex;
    flex-direction: row;
    flex: 1;
    width: 100%;
    // height: 200px;

    .rw-box-figure {
      width: 320px;
      background: #b0bec5;
      .tab {
        display: flex;
        flex-direction: row;
        padding: 8px;
      }
    }
    .rw-box-warn {
      position: relative;
      flex: 1;
      height: 100%;
      .rw-box-list {
        position: absolute;
        flex: 1;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        .rw-no-regist {
          font-size: 1rem;
        }
      }
    }
  }
}

.rw-content-warn {
  padding-top: 0;
  padding-bottom: 0;
  flex: 2;

  .rw-item-warn {
    display: flex;

    .rw-span-warn-box {
      flex: 1;

      min-width: 120px;
      .rw-span-warn {
        font-size: 10pt;
        display: inline-block;
        padding: 4px 4px 4px 4px;
        border-radius: 4px;
      }
      .rw-span-warn-normal {
        font-size: 10pt;
        display: inline-block;
        padding: 3px 3px 3px 3px;
        border-radius: 4px;
        border: solid 1px black;
      }
    }
    .rw-span-rvr {
      flex: 1;
      white-space: pre-wrap;
    }
  }

  .rw-item-heading {
    padding-top: 6px;
    font-size: 10pt;
    font-weight: bold;
  }
}

.rw-span-time {
  min-width: 200px;
  display: flex;
  justify-content: flex-end;
  padding-right: 24px;
  .rw_span_new {
    font-size: 10pt;
    display: inline-block;
    padding: 4px 4px 4px 4px;
    border-radius: 4px;
    background-color: $color-newcome;
    color: white;
  }
  .rw-span-annNo {
    padding-left: 4px;
    font-weight: bold;
  }
}

.rw-span-warn {
  min-height: 24px;
  font-size: 10pt;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border-radius: 4px;
}

.rw-span-warn-normal {
  min-height: 24px;
  font-size: 10pt;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border-radius: 4px;
  border: solid 1px black;
}

.rw-legend-img {
  width: 100%;
}

.rw-span-text {
  white-space: pre-wrap;
}

.rw-span-expanel {
  white-space: normal;
  max-width: 90%;
}

.rw-target {
  font-size: 11pt;
}

.vc-dialog-content {
  position: absolute;
  background-color: rgba(lightgray, 0.8);
  z-index: 3030;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
